import { User } from '../types/items';

export type Guard = (user: User) => boolean;

export const roles = {
  admin: 'is_admin',
  superAdmin: 'is_super_admin',
  user: 'is_active',
  inOrganization: 'organization_id',
} as const;

export type Role = ValueOf<typeof roles>;

export const not = (role: Role): Guard => (user) => !user[role];
export const is = (role: Role): Guard => (user) => Boolean(user[role]);

export const and = (...guards: Guard[]): Guard => (user) => guards.every((guard) => guard(user));
export const or = (...guards: Guard[]): Guard => (user) => guards.some((guard) => guard(user));
